import { FC, SVGProps } from 'react';

export const SmsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 6.75C5.86193 6.75 5.75 6.86193 5.75 7V25.1534L8.65288 22.1693C8.79408 22.0242 8.98798 21.9423 9.19048 21.9423H26C26.1381 21.9423 26.25 21.8304 26.25 21.6923V7C26.25 6.86193 26.1381 6.75 26 6.75H6ZM4.25 7C4.25 6.0335 5.0335 5.25 6 5.25H26C26.9665 5.25 27.75 6.0335 27.75 7V21.6923C27.75 22.6588 26.9665 23.4423 26 23.4423H9.50721L5.53759 27.523C5.32476 27.7418 5.00057 27.8097 4.71777 27.6949C4.43498 27.58 4.25 27.3052 4.25 27V7Z"
			fill="currentColor"
		/>
	</svg>
);
